export const CREATE_PURCHASE_LOCATION_REQUEST = 'CREATE_PURCHASE_LOCATION_REQUEST';
export const CREATE_PURCHASE_LOCATION_SUCCESS = 'CREATE_PURCHASE_LOCATION_SUCCESS';
export const CREATE_PURCHASE_LOCATION_FAILED = 'CREATE_PURCHASE_LOCATION_FAILED';

export const UPDATE_PURCHASE_LOCATION_REQUEST = 'UPDATE_PURCHASE_LOCATION_REQUEST';
export const UPDATE_PURCHASE_LOCATION_SUCCESS = 'UPDATE_PURCHASE_LOCATION_SUCCESS';
export const UPDATE_PURCHASE_LOCATION_FAILED = 'UPDATE_PURCHASE_LOCATION_FAILED';

export const GET_PURCHASE_LOCATION_REQUEST = 'GET_PURCHASE_LOCATION_REQUEST';
export const GET_PURCHASE_LOCATION_SUCCESS = 'GET_PURCHASE_LOCATION_SUCCESS';
export const GET_PURCHASE_LOCATION_FAILED = 'GET_PURCHASE_LOCATION_FAILED';

export const DISABLE_PURCHASE_LOCATION_REQUEST = 'DISABLE_PURCHASE_LOCATION_REQUEST';
export const DISABLE_PURCHASE_LOCATION_SUCCESS = 'DISABLE_PURCHASE_LOCATION_SUCCESS';
export const DISABLE_PURCHASE_LOCATION_FAILED = 'DISABLE_PURCHASE_LOCATION_FAILED';

export const SET_PURCHASE_LOCATION = 'SET_PURCHASE_LOCATION';
